const utms = ["utm_source", "utm_medium", "utm_term", "utm_content", "utm_campaign", "gclid"];

function getStringInBetween(string, start, end) {
	let indexOfStart = string.indexOf(start);
	indexOfStart = indexOfStart + start.length;

	const newString = string.slice(indexOfStart);

	const indexOfEnd = newString.indexOf(end);

	return newString.slice(0, indexOfEnd);
}

const extractUtmFromString = string => {
	const values = {};

	utms.forEach(utm => {
		if (string.includes(`${utm}=`)) {
			let value = getStringInBetween(string, `${utm}=`, ";");

			if (value) {
				if (value.includes("&")) {
					value = value.split("&")[0];
				}

				values[utm] = value;
			}
		}
	});

	return values;
};

const extractUtmFromObject = object => {
	const values = {};

	utms.forEach(utm => {
		const value = object[utm];

		if (value) {
			values[utm] = value;
		}
	});

	return values;
};

window.extractUtmFromString = extractUtmFromString;
window.extractUtmFromObject = extractUtmFromObject;

export { extractUtmFromString, extractUtmFromObject };
